import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { get } from 'lodash';
function getPdfUrl(contact, coreUrl) {
  var _context;
  var url = get(contact, 'consent.file_uploads[0].path', '');
  return _concatInstanceProperty(_context = "".concat(coreUrl)).call(_context, url);
}
export default getPdfUrl;
//# sourceMappingURL=getPdfUrl.js.map